<template>
  <div>
    <v-layout class="ml-3 mr-3" row wrap>
      <v-flex xs12>
        <transition name="slide">
          <v-layout
            row
            wrap
            v-if="showUpload"
            style="background-color: #fff"
            class="mx-1 mt-0 px-4 pt-4 mb-4"
          >
            <!-- // TITLE -->
            <v-flex xs12 md6 pr-2 mt-2>
              <v-text-field
                v-model="todo.title"
                class="ml-2"
                name="description"
                label="Description"
              ></v-text-field>
            </v-flex>

            <!-- // DEADLINE -->
            <v-flex xs12 sm6 md3 pl-2 pr-2>
              <v-menu
                ref="menu2"
                v-model="menu2"
                :return-value.sync="todo.deadline"
                :close-on-content-click="false"
                class="my-1"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                :nudge-right="0"
                lazy
              >
                <v-text-field
                  slot="activator"
                  v-model="todo.deadline"
                  prepend-inner-icon="event"
                  readonly
                  label="Deadline"
                ></v-text-field>
                <v-date-picker
                  :min="format_date(Date.now())"
                  color="black"
                  v-model="todo.deadline"
                  @input="$refs.menu2.save(todo.deadline)"
                  first-day-of-week="1"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- // REMINDER -->
            <v-flex xs12 sm6 md3 pl-1 pr-2 v-if="todo.deadline">
              <v-menu
                ref="menu3"
                v-model="menu3"
                :return-value.sync="todo.reminder"
                :close-on-content-click="false"
                class="my-1"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                :nudge-right="30"
                lazy
                landscape
              >
                <v-text-field
                  slot="activator"
                  v-model="todo.reminder"
                  prepend-inner-icon="event"
                  readonly
                  label="Reminder"
                ></v-text-field>
                <v-date-picker
                  color="black"
                  :min="format_date(Date.now())"
                  scrollable
                  v-model="todo.reminder"
                  @input="$refs.menu3.save(todo.reminder)"
                  first-day-of-week="1"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                auto-grow
                rows="1"
                v-model="todo.description"
                class="mx-2 my-2"
                name="note"
                label="Note"
              ></v-textarea>
            </v-flex>

            <!-- REPEAT -->
            <v-flex xs12 sm4 md2 mt-2 pr-3>
              <!-- style="width:100px;" -->
              <div class="ml-2">
                Repeat every …
              </div>
              <!-- label="Repeat every …" -->
              <v-text-field
                v-model="todo.frequency"
                class="ml-2 xs2"
                name="frequency"
                prepend-inner-icon="loop"
                hide-details
              ></v-text-field>
              <div v-if="todo.repeat && !todo.frequency" class="red--text ml-2">
                Must be filled!
              </div>
            </v-flex>

            <!-- repeat buttons -->
            <v-flex xs12 sm8 md4 ml-0 mt-5>
              <v-btn-toggle v-model="todo.repeat" class="mt-0" small>
                <!-- <v-toggle-button v-model="todo.repeat" class="xs8 sm6 pb-2 ml-3 row"> -->
                <v-btn
                  flat
                  small
                  key="group1"
                  class="px-3"
                  input-value="day"
                  value="day"
                >
                  <span>Days</span>
                </v-btn>
                <v-btn
                  flat
                  small
                  key="group2"
                  class="px-3"
                  input-value="month"
                  value="month"
                >
                  <span>Months</span>
                </v-btn>
                <v-btn
                  flat
                  small
                  key="group3"
                  class="px-3"
                  input-value="year"
                  value="year"
                >
                  <span>Years</span>
                </v-btn>
                <!-- <v-btn value="day" label="Days" key="day"></v-btn>
                <v-btn value="month" label="Months" key="month"></v-btn>
                <v-btn value="year" label="Years" key="year"></v-btn>-->
              </v-btn-toggle>
              <div v-if="!todo.repeat && todo.frequency" class="red--text ml-3">
                Must be selected!
              </div>
            </v-flex>

            <!-- users -->
            <v-flex pl-2 mt-3 sm12 md6>
              <!-- <v-container xs12 ml-0 mt-0 pt-0>
              <v-layout wrap>-->
              <!-- <v-flex xs3> -->
              <!-- <h3 class="mb-0 pb-0">Assigned to:</h3> -->
              <!-- </v-flex> -->
              <!-- prepend-icon="person" -->
              <v-flex xs12 pr-2>
                <v-autocomplete
                  v-model="todo.user_ids"
                  :items="team_d"
                  chips
                  color="blue-grey lighten-2"
                  label="Assigned to"
                  item-text="abb"
                  item-value="id"
                  multiple
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      small
                      class="chip--select-multi"
                      @input="remove(data.item)"
                    >
                      <v-avatar color="black">
                        <span class="white--text">{{ data.item.abb }}</span>
                        <!-- <img src="http://www.tb-cms.org/simone3.jpg"> -->
                      </v-avatar>
                      {{ data.item.firstname }} {{ data.item.lastname }}
                    </v-chip>
                  </template>

                  <template slot="item" slot-scope="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content
                        v-text="data.item"
                      ></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-avatar>
                        <v-icon>person</v-icon>
                        <!-- <span class="white--text headline">{{data.item.abb}}</span> -->
                        <!-- <img src="http://www.tb-cms.org/simone3.jpg"> -->
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{ data.item.abb }} - {{ data.item.firstname }}
                          {{ data.item.lastname }}</v-list-tile-title
                        >
                        <!-- <v-list-tile-sub-title v-html="data.item.id"></v-list-tile-sub-title> -->
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
              <!-- </v-layout>
              </v-container>-->
              <!-- </v-flex>

              <v-flex xs12 md6 mt-0 pr-3 layout>-->

              <!-- <h3 class="ml-3">When done, notify:</h3> -->

              <!-- <v-container xs12 ml-0 pt-0 mt-0>
              <v-layout wrap>-->
              <!-- <v-flex xs12 lg6>
                <v-autocomplete
                  v-model="todo.notify"
                  :items="team_d"
                  chips
                  color="blue-grey lighten-2"
                  label="When done, notify …"
                  prepend-icon="person"
                  item-text="abb"
                  item-value="id"
                  multiple
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      :selected="data.selected"
                      close small 
                      class="chip--select-multi"
                      @input="remove(data.item)"
                    >
                      <v-avatar color="black">
                        <span class="white--text">{{data.item.abb}}</span>
                      </v-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title> {{ data.item.firstname }} {{ data.item.lastname }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-chip>
                  </template>

                  <template slot="item" slot-scope="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-avatar>
                        <span class="white--text headline">{{data.item.abb}}</span>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title> {{ data.item.firstname }} {{ data.item.lastname }}</v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>-->
            </v-flex>

            <v-flex class="xs12 layout my-2">
              <span class="ml-2" v-if="todo.created_at"
                >{{ format_date(todo.created_at) }} by
                {{ get_abb(todo.created_by) }}</span
              >
              <v-spacer></v-spacer>
              <v-btn @click="cancel" small flat class="mb-3">cancel</v-btn>
              <v-btn @click="save_todo" small dark>create todo</v-btn>
            </v-flex>
          </v-layout>
        </transition>
      </v-flex>
    </v-layout>

    <v-layout row wrap xs12 mx-0 mt-2>
      <v-flex xs12>
        <v-btn-toggle small mandatory v-model="visibility" class="mt-0 ml-4">
          <v-btn
            flat
            small
            key="group1"
            class="px-3"
            input-value="active"
            value="active"
          >
            <span>Active</span>
          </v-btn>
          <v-btn
            flat
            small
            key="group2"
            class="px-3"
            input-value="all"
            value="all"
          >
            <span>All</span>
          </v-btn>
          <v-btn
            flat
            small
            key="group3"
            class="px-3"
            input-value="completed"
            value="completed"
          >
            <span>Done</span>
          </v-btn>
        </v-btn-toggle>
        <v-btn
          small
          icon
          v-if="!showUpload && c_user.edit"
          class="right primary mt-0 mb-0 mr-3 xs12"
          @click="new_todo()"
        >
          <v-icon small>add</v-icon>
        </v-btn>
      </v-flex>

      <v-flex
        class="xs12 text-xs-center my-5 mx-4 headline pa-5 elevation-2"
        v-if="filteredTodos && filteredTodos.length == 0"
      >
        NO TODOS
      </v-flex>
    </v-layout>

    <!-- LIST -->
    <v-layout row wrap xs12 mx-3 mt-2 mb-5>
      <!-- <v-slide-y-transition group tag="v-card"> -->
      <v-flex :key="t.id + 'todo'" xs12 md12 lg6 xl4 v-for="t in filteredTodos">
        <v-card
          class="mt-1 pa-0 ml-2 mb-1"
          xs12
          :color="t.done == 1 ? '#ddd' : '#fff'"
          hover
          style="cursor:default;"
        >
          <v-layout xs12 row pb-0 mb-0>
            <v-flex xs4 mt-1 pl-0 ml-0 mr-5 pb-0 mb-0>
              <v-btn
                flat
                :class="t.done == 1 ? 'dark' : ''"
                @click="done_todo(t)"
              >
                <v-icon
                  v-if="t.done != 1"
                  class="mr-2 pl-0 ml-0"
                  :color="t.done == 1 ? 'black' : 'red'"
                  >check_box_outline_blank</v-icon
                >
                <v-icon v-else class="mr-2" color="black">check_box</v-icon>
                <span v-if="t.done == 1">DONE</span>
                <span v-else="t.done != 1" class="red--text">ACTIVE</span>
              </v-btn>
            </v-flex>

            <!-- <v-flex xs4 pr-4 mt-3 text-xs-left>
                <span class="ma-0 pt-0">
                  <v-icon small>event</v-icon>
                  {{ format_date(t.created_at) }} {{ get_abb(t.created_by)}}
                </span>
              </v-flex> -->

            <v-flex xs4 pr-4 mt-3 text-xs-center>
              <div v-if="t.deadline != null">
                <span class="ma-0 pt-0" v-if="!t.done">
                  <v-icon small :color="getColor(t)">alarm_on</v-icon>
                  {{ format_date(t.deadline) }}
                </span>
                <span v-else class="ma-0 pt-0">
                  <v-icon small :color="getColor(t)">check_circle</v-icon>
                  <span v-if="t.done_at != null">{{
                    format_date(t.done_at)
                  }}</span>
                </span>
              </div>
            </v-flex>

            <v-flex xs4 mt-1 text-xs-right>
              <v-btn
                @click="delete_todo(t)"
                icon
                v-if="c_user.edit == 1 || c_user.delete_rights == 1"
              >
                <v-icon color="red" small>mdi-trash-can-outline</v-icon>
              </v-btn>
              <v-btn
                @click="edit_todo(t.id)"
                icon
                class="mr-3"
                v-if="c_user.edit == 1"
              >
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <!-- </v-container> -->
          <v-divider class="xs12 mt-0 pt-0 mb-3"></v-divider>

          <v-card-text
            v-if="t.title"
            class="title font-weight-normal my-0 py-0 pl-4 pr-4 wrap"
            >{{ t.title.toUpperCase() }}</v-card-text
          >

          <v-card-text class="wrap pt-2 pl-4" v-if="t.description">{{
            t.description
          }}</v-card-text>
          <v-card-text class="wrap pt-2 pl-4">
            <!-- <v-icon small>event</v-icon> -->
            {{ format_date(t.created_at) }} by {{ get_abb(t.created_by) }}
          </v-card-text>

          <v-layout row wrap xs12 align-end justify-end>
            <!-- style="position: absolute; bottom: 0; right:0;" -->
            <v-container
              class="mb-2 mr-3 pr-0 pb-0"
              align-end
              justify-end
              text-xs-right
            >
              <v-container ma-0 pa-0 mr-2 v-if="t.users && t.users.length > 0">
                <v-chip
                  v-for="u in t.users"
                  :color="!t.done ? 'black' : 'white'"
                  :text-color="t.done ? 'black' : 'white'"
                  avatar
                  small
                  :key="u.id"
                  >{{ get_abb(u.id) }}
                </v-chip>
              </v-container>
            </v-container>
          </v-layout>
        </v-card>
      </v-flex>

      <!-- <v-list-tile :key="t.id+ 'todo_upload'" v-if="showUpload2">
                <v-flex mb-5>
                  <h3 class="pl-3">Uploaded files</h3>
                  <upload
                    :artwork="artwork"
                    :todo="t.id"
                    class="xs12 mx-0 px-0"
                    style="width:100%;"
                    :field="{title:'Todo Uploads'}"
                    uploadCategory="todo"
                  ></upload>
                </v-flex>
      </v-list-tile>-->

      <!-- </v-slide-y-transition> -->
    </v-layout>
  </div>
</template>

<script>
// const FILTERS = {
//   all(all_todos) {
//     return all_todos;
//   },
//   active(all_todos) {
//     return all_todos.filter(todo => todo.done != 1);
//   },
//   completed(all_todos) {
//     return all_todos.filter(todo => todo.done == 1);
//   }
// };
import { serverBus } from '../../main'
import axios from 'axios'
export default {
  props: ['artwork'],
  data: () => ({
    editing: false,
    // editedTodo: {},
    visibility: 'active',
    active_todos: [],
    loading: false,
    showUpload: false,
    showUpload2: false,
    show: false,
    menu2: false,
    menu3: false,
    todo: {
      description: '',
      title: '',
      deadline: '',
      reminder: '',
      done: false,
      done_at: '',
      repeat: '',
      user_ids: [],
      notify: []
    },
    todos: []
  }),
  mounted() {
    // if (this.artwork.artwork_todos && this.artwork.artwork_todos.length > 0) {
    if (this.artwork) {
      this.todos = this.$store.state.todos.filter(
        t => t.artwork_id === this.artwork.id
      )
      // this.todo.users = this.todo.users.map(u => this.$store.state.users.find(us => us.id == u.id))
      // console.log('this.artwork.id')
      // console.log(this.$store.state.todos)
      // console.log(this.todos.length)
      // console.log(this.artwork.id)
    } else {
      this.todos = this.$store.state.todos.filter(
        t => t.artwork_id === this.$route.query.id
      )
      // console.log('this.$route.query.id')
      // console.log(this.$route.query.id)
    }
    // artwork.artwork_todos;
    // } else {
    //   return [];
    // }
  },
  computed: {
    // all_todos() {
    //   return this.todos;
    // },
    team_d() {
      var f = Object.assign(this.$store.state.users)
      return f.filter(u => u.enable == 'Y' && u.edit == 1)
    },
    filteredTodos: function() {
      var todos = this.$store.state.todos.filter(
        t => t.artwork_id === this.artwork.id
      )
      //if (this.artwork) {
      //  todos = todos.filter(t => t.artwork_id === this.artwork.id)
      //} else {
      //  todos = todos.filter(t => t.artwork_id === this.$route.query.id)
      //}
      if (this.visibility == 'all') {
        return todos
      } else if (this.visibility == 'active') {
        return todos.filter(t => t.done != 1)
      } else if (this.visibility == 'completed') {
        return todos.filter(t => t.done == 1)
      }
      // }
      // return FILTERS[this.visibility](this.todos);
      // }
      // remaining: function() {
      //   return filters.active(this.todos).length;
      // },
      // allDone: {
      //   get: function() {
      //     return this.remaining === 0;
      //   },
      //   set: function(value) {
      //     this.todos.forEach(function(todo) {
      //     a  todo.completed = value;
      //     });
      //   }
    }
  },
  methods: {
    getColor(t) {
      // console.log(this.format_date(Date.now()))
      // console.log(t.deadline)
      return t.deadline < this.format_date(Date.now()) ? 'red' : 'black'
    },
    new_todo() {
      this.editing = false
      this.todo.deadline = '' // this.format_date(Date.now())
      this.todo.reminder = '' // this.format_date(Date.now())
      this.showUpload = true
      this.todo.user_ids = []
      this.todo.user_ids.push(this.c_user.id)
      this.todo.notify = []
      this.todo.notify.push(this.c_user)
      this.todo.created_by = this.c_user.id
    },
    remove(item) {
      const index = this.todo.user_ids.indexOf(item.id)
      if (index >= 0) this.todo.user_ids.splice(index, 1)
    },
    // download() {},
    delete_todo(todo) {
      let url = `${this.$globals.apiserver}/artwork_todos/${todo.id}.json`
      axios
        .delete(url, todo)
        .then(response => {
          this.errors = {}
          const index = this.todos.indexOf(todo)
          if (index >= 0) this.todos.splice(index, 1)
          // this.artwork.artwork_todos.push(response.data);
          // this.artwork.artwork_todos = [
          //   ...this.artwork.artwork_todos.map(item =>
          //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
          //   )
          // ];
          // console.log(this.artwork.artwork_todos);
          // this.todos = this.artwork.artwork_todos;
          // this.all_todos = Object.assign([],this.artwork.artwork_todos)
          // this.active_todos.push(response.data);
          // this.todos.push(response.data);
          // this.editing = false;
          this.$emit('getArtwork')
          this.$store.dispatch('loadTodos')
          this.$store.dispatch('updateArtwork', this.artwork.id)
          // this.artwork = this.$store.state.artworks.find(
          //   a => (a.id = this.artwork.id)
          // );
        })
        .catch(error => {
          this.errors = error.response.data
        })
    },
    edit_todo(id) {
      this.editing = true
      try {
        this.todo = Object.assign(
          {},
          this.todos.find(t => t.id == id)
        )
        this.todo.user_ids = this.todo.users.map(u => u.id)
        this.todo.deadline = this.todo.deadline
          ? this.format_date(this.todo.deadline)
          : null
        this.todo.reminder = this.todo.reminder
          ? this.format_date(this.todo.reminder)
          : null
        this.showUpload = true
      } catch (error) {
        // console.log(error.message)
      }
    },
    async done_todo(tt) {
      // const todoIndex = this.todos.indexOf(t);
      // console.log(t);
      var t = Object.assign({}, tt)
      // const todoIndex = this.todos.indexOf(tt);
      if (t.done == 0 || t.done == '') {
        t.done = 1
        t.done_at = this.format_date(Date.now())
      } else {
        t.done = 0
        t.done_at = null
      }
      let url = `${this.$globals.apiserver}/artwork_todos/${t.id}.json`
      // var todoDone = {t.}
      // this.$store.dispatch('toggleTodo', tt)
      await axios
        .put(url, {
          todo: { done: t.done, done_at: t.done_at }
        })
        .then(response => {
          this.errors = {}
          this.$emit('showSnackbar', 'Todo saved.', 'green')
          // this.artwork.artwork_todos.push(response.data);
          // this.todos = [
          //   ...this.todos.map(item =>
          //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
          //   )
          // ];
          // console.log(this.artwork.artwork_todos);
          // this.todos = this.artwork.artwork_todos;
          // this.all_todos = Object.assign([],this.artwork.artwork_todos)
          // this.active_todos.push(response.data);
          // this.todos.push(response.data);
          this.editing = false
          // this.$store.dispatch("updateArtwork", this.artwork.id);
          // this.artwork = this.$store.state.artworks.find(
          //   a => (a.id = this.artwork.id)
          // );
        })
        .catch(error => {
          this.errors = error.response.data
        })
      // this.editing = false;
      this.$store.dispatch('loadTodos')
      this.$emit('getArtwork')
    },
    save_todo() {
      serverBus.$emit('showSnackbar', 'Adding new Todo …')
      // console.log(this.editing);
      // console.log(this.todo);
      // this.todo.id = this.findMinMax(this.all_todos)+1
      // if (!this.artwork.artwork_todos) {
      //   this.artwork.artwork_todos = [];
      // }

      if (this.editing) {
        // SAVING EDITED TODO
        let url = `${this.$globals.apiserver}/artwork_todos/${this.todo.id}.json`
        axios
          .put(url, {
            todo: this.todo
          })
          .then(response => {
            serverBus.$emit('showSnackbar', 'Todo saved.', 'green')
            this.errors = {}
            // console.log(response.data);
            // console.log(this.todo);
            this.$store.dispatch('saveTodo', this.editing)
            // this.artwork.artwork_todos.push(response.data);
            this.todos = [
              ...this.todos.map(item =>
                item.id !== response.data.id
                  ? item
                  : { ...item, ...response.data }
              )
            ]
            // this.todos = [
            // console.log(this.todos);
            //   ...this.todos.map(item =>
            //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
            //   )
            // ];
            // this.todos = this.artwork.artwork_todos;
            // console.log(this.todos);
            // this.artwork.artwork_todos = this.todos;
            // this.all_todos = Object.assign([],this.artwork.artwork_todos)
            // this.active_todos.push(response.data);
            // this.todos.push(response.data);
            this.editing = false
            this.$store.dispatch('updateArtwork', this.artwork.id)
          })
          .catch(error => {
            this.errors = error.response.data
            serverBus.$emit(
              'showSnackbar',
              'Problem occured while saving Todo. Try again or contact support.'
            )
            // console.log(this.errors)
          })
      } else {
        // SAVING NEW TODO
        this.todo.artwork_id = this.artwork.id
        this.todo.done = false
        this.todo.created_by = this.c_user.id
        axios
          .post(`${this.$globals.apiserver}/artwork_todos.json`, {
            todo: this.todo
          })
          .then(response => {
            this.errors = {}
            this.$store.dispatch('updateArtwork', this.artwork.id)
            this.$store.dispatch('loadTodos')
            // this.todos.push(response.data);
            // this.active_todos = this.artwork.artwork_todos
            this.$store.dispatch('addTodo', response.data)
            // this.active_todos.push(response.data);
            this.todos.push(response.data)
          })
          .catch(error => {
            this.errors = error.response.data
          })
      }
      this.showUpload = !this.showUpload
      this.todo = {
        description: '',
        title: '',
        deadline: '',
        done: false,
        done_at: '',
        team: [],
        notify: ''
      }
    },
    cancel() {
      this.showUpload = false
      this.todo = {
        description: '',
        title: '',
        deadline: '',
        reminder: '',
        done: false,
        done_at: '',
        repeat: '',
        user_ids: [],
        notify: []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/artworks/Todos.vue